import {
  Box,
  Divider,
  Flex,
  HStack,
  Modal,
  ModalContent,
  ModalOverlay,
  Select,
  Spinner,
  Text,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useContext, useEffect, useRef, useState } from 'react';
import { AiOutlineEye } from 'react-icons/ai';
import { IoEyeOffOutline } from 'react-icons/io5';
import { MdOutlineFileCopy } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';

import { FireIcon } from '../../../../../assets/icons/FireIcon';
import { LeadBtnTooltipComponent } from '../../../../../components/widgets/Tooltip';
import FilterContext from '../../../../../contexts/FilterContext';
import useUpdateEffect from '../../../../../hooks/useUpdateEffect';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../../utils/dados-login.util';
import { getProductName } from '../../../../../utils/leads.util';
import { getTelephoneOrCellPhoneNumber } from '../../gestao/utils/getTelephoneOrCellPhoneNumber';
import KanbanFilters from './KanbanFilters';
import ModalChangeStatus from './ModalChangeStatus';

type KanbanMobileProps = {
  login?: string;
};
type ShowOrHidePhoneProps = {
  phone: string;
  celphone: string;
  canShow: boolean;
};

export const KanbanMobile = ({ login }: KanbanMobileProps): JSX.Element => {
  const navigate = useNavigate();

  const initalFilters = {
    query: {
      status: '',
      'data-inicial': '',
      'data-final': '',
      campanha: '',
      'abordagem-n2': '',
      produto: '',
      abordagem: ''
    },
    headers: {
      cpf: '',
      cnpj: ''
    }
  };
  const dateFnsDayPeriod = {
    'da manhã': 'Manhã',
    'da tarde': 'Tarde',
    'da noite': 'Noite'
  };
  const userRef = useRef('123123123');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  const {
    currentPageOportunidades,
    setCurrentPageOportunidades,
    currentPageNovoContato,
    setCurrentPageNovoContato,
    currentPageEmNegociacao,
    setCurrentPageEmNegociacao,
    currentPageConcluido,
    setCurrentPageConcluido,
    // leads,
    // setLeads,
    filterObject,
    setLoadingFilters,
    orderBy
  } = useContext(FilterContext);
  const [isSearching, setSearching] = useState(false);
  const objStatusPages = [
    {
      status: 'Novas Oportunidades',
      currentPage: currentPageOportunidades
    },
    { status: 'NovoContato', currentPage: currentPageNovoContato },
    { status: 'EmNegociacao', currentPage: currentPageEmNegociacao },
    { status: 'Concluido', currentPage: currentPageConcluido }
  ];
  const [qtdState, setQtdState] = useState<any>({
    'Novas Oportunidades': 0,
    NovoContato: 0,
    EmNegociacao: 0,
    Concluido: 0
  });
  const [filterLink, setFilterLink] = useState({ query: '', headers: {} });
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState<any>();
  const mobileRef = useRef(0);
  const [loadingMoreLeads, setLoadingMoreLeads] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [mobileLeads, setMobileLeads] = useState<any>([
    {
      name: 'teste',
      email: 'teste@teste',
      cel: '343434',
      campaign: 'campanha teste 1'
    }
  ]);
  const [AllLeads, setAllLeads] = useState<any>({
    oportunidades: [],
    novoContato: [],
    emNegociacao: [],
    concluidos: []
  });
  const leadsJuntos = useRef<any>([
    {
      name: 'teste',
      email: 'teste@teste',
      cel: '343434',
      campaign: 'campanha teste'
    }
  ]);

  const [loadingPagination, setLoadingPagination] = useState({
    novasOportunidades: false,
    novoContato: false,
    emNegociacao: false,
    concluido: false
  });

  const [selectedStatus, setSelectStatus] = useState<any>({
    name: 'Novas Oportunidades',
    color: '#001E64',
    id: 1,
    items: [],
    status: 'oportunidades'
  });

  const [statusStep, setStatusStep] = useState<any>([
    {
      name: 'Novas Oportunidades',
      color: '#001E64',
      id: 1,
      items: [],
      status: 'oportunidades'
    },
    {
      name: 'Fazer novo contato',
      color: '#001E64',
      id: 2,
      items: [],
      status: 'novoContato'
    },
    {
      name: 'Em negociação',
      color: '#001E64',
      id: 3,
      items: [],
      status: 'emNegociacao'
    },
    {
      name: 'Concluído',
      color: '#001E64',
      id: 4,
      items: [],
      status: 'concluidos'
    }
  ]);

  const toast = useToast();
  const handleChangeStatus = (status: string) => {
    const getStatus = statusStep.find(
      (element: any) => element.status === status
    );
    const getLeads = AllLeads[status];
    setSelectStatus({ ...getStatus });
    setMobileLeads([...getLeads]);
  };

  const handleUpdateLead = (status: string, lead: any) => {
    if (status === '') return;
    setSaveStatus(lead);
    setNewStatus(status);
    onOpen();
  };

  const ShowOrHidePhone = ({
    phone,
    celphone,
    canShow
  }: ShowOrHidePhoneProps) => {
    const formatCel = (number = '') => {
      if (!number) return '';

      let formating = String(number).replace(/\D/g, '');

      formating = formating.replace(/^0/, '');

      if (formating.length >= 12) {
        formating = formating.slice(2);
        if (formating.length === 10) {
          formating = formating.replace(
            /^(\d\d)(\d{4})(\d{4}).*/,
            '($1) $2-$3'
          );
          return formating;
        }
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length === 11) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 10) {
        formating = formating.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (formating.length > 5) {
        formating = formating.replace(
          /^(\d\d)(\d{4})(\d{0,4}).*/,
          '($1) $2-$3'
        );
      } else if (formating.length > 2) {
        formating = formating.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
      } else {
        formating = formating.replace(/^(\d*)/, '($1)');
      }
      return formating;
    };

    const getTelephoneOrCellPhoneNumber = (telephone: any, cell: any) => {
      const telephoneFormatted = telephone?.replace(/\D/g, '');
      const cellFormatted = cell?.replace(/\D/g, '');

      let phoneNumber = '';

      if (
        cellFormatted &&
        telephoneFormatted &&
        telephoneFormatted?.length >= 10 &&
        cellFormatted?.length >= 10
      ) {
        phoneNumber = `${cellFormatted} / ${telephoneFormatted}`;
      } else if (telephoneFormatted && telephoneFormatted?.length >= 10) {
        phoneNumber = `${telephoneFormatted}`;
      } else if (cellFormatted && cellFormatted?.length >= 10) {
        phoneNumber = `${cellFormatted}`;
      } else {
        phoneNumber = '';
      }

      return phoneNumber;
    };
    if (!canShow) {
      const ddd = phone.slice(0, 2);

      return (
        <>
          <p>{ddd}</p>
          <div className="tw-w-[5.73188rem] tw-h-[1.48188rem] tw-bg-[#ececec] tw-blur-[2px]" />
        </>
      );
    } else return <p>{getTelephoneOrCellPhoneNumber(phone, celphone)}</p>;
  };

  const identifyStatus = (status) => {
    switch (true) {
      case status === 'Novas Oportunidades':
        return 'oportunidades';
      case status === 'NovoContato':
        return 'novoContato';
      case status === 'EmNegociacao':
        return 'emNegociacao';
      case status === 'Concluido':
        return 'concluidos';
      default:
        return '';
    }
  };

  const updateLead = (lead, newStatus, changes) => {
    const identifyOldStatus = identifyStatus(lead.STATUS__c);
    const identifyNewStatus = identifyStatus(newStatus);

    const itemsDestiny = AllLeads[identifyNewStatus];
    const itemsStart = AllLeads[identifyOldStatus];

    const indexLead = itemsStart.findIndex((item) => {
      return item.ID_LEAD__c === lead.ID_LEAD__c;
    });

    itemsStart.splice(indexLead, 1);

    if (newStatus === 'NovoContato') {
      const newValuesLead = {
        ...lead,
        STATUS__c: newStatus,
        DATA_AGENDAMENTO__c: {
          _seconds: changes?.data_agendamento / 1000,
          _nanoseconds: 0
        }
      };
      itemsDestiny[indexLead] = newValuesLead;
    }
    if (newStatus === 'EmNegociacao') {
      const newValuesLead = {
        ...lead,
        ABORDAGEM_N2__c: changes?.abordagem_n2,
        STATUS__c: newStatus
      };
      itemsDestiny[indexLead] = newValuesLead;
    }
    if (newStatus === 'Concluido') {
      const newValuesLead = {
        ...lead,
        ABORDAGEM__c: changes?.abordagem,
        ABORDAGEM_N2__c: changes?.abordagem_n2,
        PRODUTOS__c: changes?.produtos,
        STATUS__c: newStatus
      };
      itemsDestiny[indexLead] = newValuesLead;
    }
    //Alteração de indicadores de status
    setQtdState((prevState) => {
      return {
        ...prevState,
        ...prevState,
        [newStatus]: (prevState[newStatus] || 0) + 1,
        [lead.STATUS__c]: prevState[lead.STATUS__c] - 1
      };
    });

    setAllLeads({
      ...AllLeads,
      [identifyOldStatus]: [...itemsStart],
      [identifyNewStatus]: [...itemsDestiny]
    });
  };

  const getVisualizedStatus = (
    visualized: boolean,
    arrayVisualized: any
  ): 'visualizado' | 'nao-visualizado' => {
    if (visualized === true) {
      return 'visualizado';
    }
    return 'nao-visualizado';
  };

  const showStatus = (actualStatus: string) => {
    switch (true) {
      case actualStatus === 'Novas Oportunidades':
        return [
          { nome: 'Agendado', id: 'NovoContato' },
          { nome: 'Em Negociação', id: 'EmNegociacao' },
          { nome: 'Concluído', id: 'Concluido' }
        ];
      case actualStatus === 'NovoContato':
        return [
          { nome: 'Em Negociação', id: 'EmNegociacao' },
          { nome: 'Concluído', id: 'Concluido' }
        ];
      case actualStatus === 'EmNegociacao':
        return [{ nome: 'Concluído', id: 'Concluido' }];
      case actualStatus === 'Concluido':
        return [];

      default:
        return [];
    }
  };

  const getTypeUser = async () => {
    setLoading(true);
    try {
      const dadosLogin = await getDadosLogin();

      userRef.current = dadosLogin.codeNac || null;
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const setReason = (reason: string) => {
    switch (reason) {
      case 'lgpd-bloqueado':
        return 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato';
      case 'nao-responde':
        return 'Não responde | sem interação nos contatos realizados';
      case 'dados-invalidos':
        return 'Dados inválidos';
      case 'preco':
        return 'Preço';
      case 'fora-rede':
        return 'Fora da rede credenciada | Fora da área de abrangência | Localização';
      case 'concorrencia':
        return 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor';
      case 'cnpj-inativo':
        return 'CNPJ inativo | Emissão de certidão negativa';
      case 'mei-menos':
        return 'MEI menos de 6 meses';
      case 'pj-1-vida':
        return 'PJ para 1 vida';
      case 'ja-contratou':
        return 'Já contratou';
      case 'converteu-saude':
        return 'Interesse em outros produtos | Converteu Saúde';
      case 'converteu-odonto':
        return 'Interesse em outros produtos | Converteu Odonto';
      case 'converteu-vida':
        return 'Interesse em outros produtos | Converteu Vida';
      case 'converteu-viagem':
        return 'Interesse em outros produtos | Converteu Viagem';
      case 'sem-interesse':
        return 'Não teve interesse';
      case 'recusa-sula':
        return 'Recusa SulAmérica DPS';
      default:
        return 'Nenhum motivo';
    }
  };

  const copyText = (text: string) => {
    navigator.clipboard.writeText(text.replace(/[^A-Z0-9]+/gi, ''));
    toast({
      position: 'bottom',
      description: 'Texto copiado com sucesso.',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const copyEmail = (text: string) => {
    navigator.clipboard.writeText(text);
    toast({
      position: 'bottom',
      description: 'Texto copiado com sucesso.',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const getFiltersPath = (lastItem: string | number, leadStatus: string) => {
    const path = lastItem
      ? `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=10&status=${leadStatus}&cursor=${lastItem}`
      : `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=10&status=${leadStatus}`;

    return path;
  };

  const getFiltersModalPath = (
    leadStatus: string,
    lastItem: string | number
  ) => {
    let queryStatus = '';
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }
    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === '' ||
        filter === 'status'
      ) {
        delete filterFormatQuery[filter];
      }
    }
    const filterURL = '' + new URLSearchParams(filterFormatQuery).toString();

    queryStatus =
      `${filterURL !== '' ? filterURL : ''}` + '&status=' + leadStatus;

    const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=10&${queryStatus}${
      lastItem ? '&cursor=' + lastItem : ''
    }`;

    return path;
  };

  const getLeads = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem('tokenPortal');

      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(getFiltersPath(undefined, params.status));
            }
          })
          .filter((item) => Boolean(item))
      );

      const leadsObj = {};

      const tipo = responses[0].data.tipo;

      // const responsesCampanhas = await apiSensedia.get(
      //   `oportunidades-sulamerica/painel-leads/consultar-leads?campanhas=true`
      // );
      const indicadoresObj = {};

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });
      setQtdState(indicadoresObj);

      const objLead = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };
      leadsJuntos.current = [
        ...objLead.oportunidades,
        ...objLead.novoContato,
        ...objLead.emNegociacao,
        ...objLead.concluidos
      ];

      setAllLeads({
        oportunidades: [...objLead.oportunidades],
        novoContato: [...objLead.novoContato],
        emNegociacao: [...objLead.emNegociacao],
        concluidos: [...objLead.concluidos]
      });
      setMobileLeads(objLead.oportunidades);
      setLoading(false);
    } catch (error: any) {
      setMobileLeads([]);
      setLoading(false);
    }
  };

  const handleFilters = async () => {
    setLoading(true);
    setLoadingFilters(true);
    let filterFormatQuery = {
      ...filterObject.query
    };
    if (orderBy.direcao !== '') {
      filterFormatQuery = {
        ...filterObject.query,
        ...orderBy
      };
    }

    const filterFormatHeader = {
      ...filterObject.headers
    };

    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === ''
      ) {
        delete filterFormatQuery[filter];
      }
    }

    for (const filter in filterFormatHeader) {
      if (
        filterFormatHeader[filter] === null ||
        filterFormatHeader[filter] === ''
      ) {
        delete filterFormatHeader[filter];
      }
    }
    const filterURL = '&' + new URLSearchParams(filterFormatQuery).toString();

    setCurrentPageOportunidades(1);
    setCurrentPageNovoContato(1);
    setCurrentPageEmNegociacao(1);
    setCurrentPageConcluido(1);

    if (filterFormatQuery.status) {
      const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=200${
        filterURL !== '&' ? filterURL : ''
      }`;

      const { data } = await apiSensedia.get(path, {
        headers: { ...filterFormatHeader }
      });

      const filteredLeads = {
        concluidos:
          data.leads.filter((lead) => lead.STATUS__c === 'Concluido') || [],
        emNegociacao:
          data.leads.filter((lead) => lead.STATUS__c === 'EmNegociacao') || [],
        novoContato:
          data.leads.filter((lead) => lead.STATUS__c === 'NovoContato') || [],
        oportunidades:
          data.leads.filter(
            (lead) => lead.STATUS__c === 'Novas Oportunidades'
          ) || []
      };
      const indicadoresObj = {};

      indicadoresObj[data.leads[0]?.STATUS__c] = data.quantidade_leads;

      const objLeads = filteredLeads;

      leadsJuntos.current = [
        ...objLeads.oportunidades,
        ...objLeads.novoContato,
        ...objLeads.emNegociacao,
        ...objLeads.concluidos
      ];

      setAllLeads({
        oportunidades: [...objLeads.oportunidades],
        novoContato: [...objLeads.novoContato],
        emNegociacao: [...objLeads.emNegociacao],
        concluidos: [...objLeads.concluidos]
      });

      setQtdState(indicadoresObj);
      setMobileLeads(objLeads.oportunidades);
      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLoading(false);
      setLoadingFilters(false);
      return;
    } else {
      const path = `${filterURL !== '&' ? filterURL : ''}`;

      const responses = await Promise.all(
        objStatusPages
          .map((params) => {
            if (params.status !== 'nao-atendeu') {
              return apiSensedia.get(
                getFiltersPath(undefined, params.status) + path,
                {
                  headers: { ...filterFormatHeader }
                }
              );
            }
          })
          .filter((item) => Boolean(item))
      );

      const leadsObj = {};
      const indicadoresObj = {};
      const tipo = responses[0].data.tipo;

      responses.forEach((item) => {
        if (item.data.leads?.length > 0) {
          leadsObj[item.data.leads[0].STATUS__c] = item.data.leads;
          indicadoresObj[item.data.leads[0].STATUS__c] =
            item.data.quantidade_leads;
        }
      });

      const objLeads = {
        tipo: tipo,
        concluidos: leadsObj['Concluido'] || [],
        emNegociacao: leadsObj['EmNegociacao'] || [],
        novoContato: leadsObj['NovoContato'] || [],
        oportunidades: leadsObj['Novas Oportunidades'] || []
      };

      leadsJuntos.current = [
        ...objLeads.oportunidades,
        ...objLeads.novoContato,
        ...objLeads.emNegociacao,
        ...objLeads.concluidos
      ];

      setAllLeads({
        oportunidades: [...objLeads.oportunidades],
        novoContato: [...objLeads.novoContato],
        emNegociacao: [...objLeads.emNegociacao],
        concluidos: [...objLeads.concluidos]
      });
      setQtdState(indicadoresObj);
      setMobileLeads(objLeads.oportunidades);
      setFilterLink({ query: path, headers: { ...filterFormatHeader } });
      setLoadingFilters(false);
      setLoading(false);
    }
  };

  const returnStatusLoading = (status: boolean) => {
    if (status === true) {
      if (selectedStatus.status === 'oportunidades') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          novasOportunidades: true
        }));
      }

      if (selectedStatus.status === 'novoContato') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          novoContato: true
        }));
      }

      if (selectedStatus.status === 'emNegociacao') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          emNegociacao: true
        }));
      }

      if (selectedStatus.status === 'concluidos') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          concluido: true
        }));
      }
    }
    if (status === false) {
      if (selectedStatus.status === 'oportunidades') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          novasOportunidades: false
        }));
      }

      if (selectedStatus.status === 'novoContato') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          novoContato: false
        }));
      }

      if (selectedStatus.status === 'emNegociacao') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          emNegociacao: false
        }));
      }

      if (selectedStatus.status === 'concluidos') {
        setLoadingPagination((prevState) => ({
          ...prevState,
          concluido: false
        }));
      }
    }
  };

  const loadMoreLeads = async () => {
    if (
      (selectedStatus.status === 'oportunidades' &&
        loadingPagination.novasOportunidades) ||
      (selectedStatus.status === 'novoContato' &&
        loadingPagination.novoContato) ||
      (selectedStatus.status === 'emNegociacao' &&
        loadingPagination.emNegociacao) ||
      (selectedStatus.status === 'concluidos' && loadingPagination.concluido)
    )
      return;

    setLoadingMoreLeads(true);

    returnStatusLoading(true);
    const statusMapping = {
      oportunidades: 'Novas Oportunidades',
      Oportunidades: 'Novas Oportunidades',
      novoContato: 'NovoContato',
      NovoContato: 'NovoContato',
      emNegociacao: 'EmNegociacao',
      EmNegociacao: 'EmNegociacao',
      concluidos: 'Concluido',
      Concluidos: 'Concluido'
    };

    const formattedStatus =
      statusMapping[selectedStatus.status] || selectedStatus.status;

    if (
      AllLeads[selectedStatus.status]?.items?.length ===
      qtdState[formattedStatus]
    ) {
      setLoadingMoreLeads(false);
      return;
    }

    let response;
    const arrayLead = AllLeads[selectedStatus.status];
    try {
      if (filterObject === initalFilters) {
        response = await apiSensedia.get(
          getFiltersPath(
            arrayLead[AllLeads[selectedStatus.status].length - 1].ID_LEAD__c,
            formattedStatus
          ),
          {
            params: {
              'tipo-consulta': 'kanban'
            }
          }
        );
      } else {
        response = await apiSensedia.get(
          getFiltersModalPath(
            formattedStatus,
            arrayLead[AllLeads[selectedStatus.status].length - 1].ID_LEAD__c
          ),
          {
            headers: { ...filterLink.headers },
            params: {
              'tipo-consulta': 'kanban'
            }
          }
        );
      }
      setAllLeads((prevState) => ({
        ...prevState,
        [selectedStatus.status]: [
          ...prevState[selectedStatus.status],
          ...response.data.leads
        ]
      }));
      returnStatusLoading(false);
      setLoadingMoreLeads(false);
    } catch (e) {
      returnStatusLoading(false);
      setLoadingMoreLeads(false);
    }
  };

  const getColorStatus = (lead, where) => {
    switch (true) {
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        !where:
        return '#006217';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == true &&
        where === 'bg':
        return 'tw-bg-[#006217]';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        !where:
        return '#AA2C23';
      case lead.STATUS__c === 'Concluido' &&
        lead.ABORDAGEM__c == false &&
        where === 'bg':
        return 'tw-bg-[#AA2C23]';
      case lead?.SOLICITOU_CONTATO__c === 'true' && !where:
        return '#FF5000';
      case lead?.SOLICITOU_CONTATO__c === 'true' && where === 'bg':
        return 'tw-bg-[#FF5000]';
      case where === 'bg':
        return 'tw-bg-[#001E64]';
      default:
        return '#001E64';
    }
  };

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY;

    // Check if the user is within a certain threshold from the bottom
    const threshold = 100; // You can adjust this value as needed

    if (scrollTop + windowHeight >= documentHeight - threshold) {
      setIsScrolledToBottom(true);
    } else {
      setIsScrolledToBottom(false);
    }
  };

  const checkHasVisualization = (
    userId: string,
    LEAD_VISUALIZADO__c: boolean
  ) => {
    return LEAD_VISUALIZADO__c === true;
  };

  const searchVisualized = (visualized: boolean, arrayVisualized: any) => {
    if (visualized === true) {
      return <AiOutlineEye size="1.1rem" />;
    }
    return <IoEyeOffOutline size="1.1rem" />;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    mobileRef.current = window.innerWidth;

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    getTypeUser();

    if (initalFilters === filterObject) {
      getLeads();
    } else {
      handleFilters();
    }
  }, [filterObject, orderBy]);

  useUpdateEffect(() => {
    if (isScrolledToBottom) {
      if (!isSearching) {
        //<- para impedir que durante a execução de uma busca não carregue uma nova pagina
        loadMoreLeads();
      }
    }
  }, [isScrolledToBottom]);

  useUpdateEffect(() => {
    if (loadingMoreLeads) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [loadingMoreLeads]);

  return (
    <>
      <KanbanFilters login={userRef.current} />
      <Box mt="1rem" px="1.5rem" w="100%">
        <Flex w="100%" justify="center">
          <Box
            w="100%"
            justifyContent="space-between"
            alignItems="center"
            display="flex"
          >
            <Text
              fontWeight="medium"
              bg={selectedStatus.color}
              w="100%"
              py="1rem"
              borderRadius="2rem"
              color="#fff"
              fontSize={'1.8vh'}
            >
              <Select
                textAlign="center"
                fontWeight="medium"
                variant="unstyled"
                w="100%"
                px="1rem"
                value={selectedStatus.status}
                onChange={(e) => {
                  handleChangeStatus(e.target.value);
                }}
              >
                <option value="oportunidades" style={{ color: 'black' }}>
                  Novas Oportunidades ({qtdState['Novas Oportunidades'] || 0})
                </option>
                <option value="novoContato" style={{ color: 'black' }}>
                  Agendado ({qtdState['NovoContato'] || 0})
                </option>
                <option value="emNegociacao" style={{ color: 'black' }}>
                  Em negociação ({qtdState['EmNegociacao'] || 0})
                </option>
                <option value="concluidos" style={{ color: 'black' }}>
                  Concluído ({qtdState['Concluido'] || 0})
                </option>
              </Select>
            </Text>
          </Box>
        </Flex>

        {!loading ? (
          AllLeads[selectedStatus.status].map((item: any, index: number) => {
            return (
              <Box
                key={index}
                display="flex"
                flexDir="column"
                bg="#fff"
                borderRadius="1.5vh"
                my="1rem"
                borderLeft={`${getColorStatus(item, null)} solid 0.5vh`}
                w={{ base: '100%' }}
                p="1rem"
              >
                <Box
                  display="flex"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Box fontWeight="bold" fontSize="1rem" w="fit-content">
                    {item.NOME__c || ''}
                  </Box>

                  <Box>
                    {item?.SOLICITOU_CONTATO__c === 'true' && (
                      <FireIcon w="1.5rem" h="2rem" />
                    )}
                  </Box>
                </Box>
                {item?.CreatedDate && (
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    fontSize="2vh"
                    mb="0.4rem"
                    fontWeight={'normal'}
                    cursor="pointer"
                  >
                    <Box
                      mr="0.4rem"
                      fontSize="1.6vh"
                      overflowWrap="break-word"
                      wordBreak="break-word"
                    >
                      {format(new Date(item?.CreatedDate), 'dd/MM/yyyy')} às{' '}
                      {format(new Date(item?.CreatedDate), 'HH:mm')}
                    </Box>
                  </Box>
                )}
                {item?.PDN_Reaberto__c === true && (
                  <Box my="0.4rem">
                    <Text
                      bg={getColorStatus(item, null)}
                      px="0.4rem"
                      w={'max-content'}
                      minW="3rem"
                      whiteSpace={'nowrap'}
                      borderRadius={'1rem'}
                      py="0.1rem"
                      textAlign={'center'}
                      color={'white'}
                    >
                      {item?.PDN_Reaberto__c === true ? 'Lead Reaberto' : ''}
                    </Text>
                  </Box>
                )}
                {item.EMAIL__c && (
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    fontSize="1rem"
                    mb="0.4rem"
                    cursor="pointer"
                    onClick={() => {
                      copyEmail(item.EMAIL__c);
                    }}
                  >
                    <Box
                      mr="0.4rem"
                      overflowWrap="break-word"
                      wordBreak="break-word"
                    >
                      {item.EMAIL__c}
                    </Box>
                    <MdOutlineFileCopy size="1.9vh" color="grey" />
                  </Box>
                )}
                {getTelephoneOrCellPhoneNumber(
                  item.TELEFONE__c,
                  item.CELULAR__c
                ) && (
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    mb="0.4rem"
                    fontSize="1rem"
                    overflowWrap="break-word"
                    wordBreak="break-word"
                    cursor="pointer"
                    onClick={() => {
                      checkHasVisualization(
                        userRef.current,
                        item.LEAD_VISUALIZADO__c
                      ) &&
                        copyText(
                          getTelephoneOrCellPhoneNumber(
                            item.TELEFONE__c,
                            item.CELULAR__c
                          )
                        );
                    }}
                  >
                    <ShowOrHidePhone
                      phone={item.TELEFONE__c || ''}
                      celphone={item.CELULAR__c || ''}
                      canShow={checkHasVisualization(
                        userRef.current,
                        item.LEAD_VISUALIZADO__c
                      )}
                    />
                    <MdOutlineFileCopy size="1.9vh" color="grey" />
                  </Box>
                )}

                {item.Campanha__c === null ? (
                  <></>
                ) : (
                  <>
                    <Text fontWeight="bold" fontSize="1rem">
                      Campanha
                    </Text>
                    <Box
                      p="0.1rem"
                      borderRadius="1rem"
                      bg={`${getColorStatus(item, null)}`}
                      w={{ base: 'fit-content' }}
                      px="0.4rem"
                      textColor="#fff"
                      display="flex"
                      justifyContent="center"
                    >
                      <span>
                        {item.Campanha__c?.length >= 20
                          ? item.Campanha__c?.substring(0, 28) + '...'
                          : item.Campanha__c}
                      </span>
                    </Box>
                  </>
                )}
                <Flex w="15rem" my="0.4rem">
                  {item?.PRODUTOS__c?.length > 0 ? (
                    <Box>
                      <Text fontWeight="bold" fontSize="1rem">
                        Produto
                      </Text>

                      <Flex gap={2} flexWrap={'wrap'}>
                        {item.PRODUTOS__c.map((product, index) => {
                          return (
                            <Text
                              color={'white'}
                              w={'fit-content'}
                              h="fit-content"
                              whiteSpace={'nowrap'}
                              borderRadius={'1rem'}
                              px="0.4rem"
                              key={index}
                              bg={getColorStatus(item, null)}
                            >
                              {getProductName(product) || ''}
                            </Text>
                          );
                        })}
                      </Flex>
                    </Box>
                  ) : (
                    <Box>
                      <Text fontWeight="bold" fontSize="1rem">
                        Produto
                      </Text>
                      <Text
                        color={'white'}
                        w={'fit-content'}
                        px="0.4rem"
                        whiteSpace={'nowrap'}
                        borderRadius={'1rem'}
                        h="fit-content"
                        bg={getColorStatus(item, null)}
                      >
                        {item.PDN_ProdutoAtual__c || '-'}
                      </Text>
                    </Box>
                  )}
                </Flex>
                {item?.NOME_CORRETOR__c && (
                  <Box my="0.4rem">
                    <Text fontWeight="bold">Corretora</Text>
                    <Text>{item.NOME_CORRETOR__c || ''}</Text>
                  </Box>
                )}
                {item?.DATA_AGENDAMENTO__c &&
                  item?.STATUS__c === 'NovoContato' && (
                    <Box
                      p="0.1rem"
                      borderRadius="1rem"
                      fontSize="1rem"
                      display="flex"
                      flexDir={'column'}
                      alignItems="start"
                      mb="0.4rem"
                    >
                      <Text fontSize="1rem" fontWeight={'bold'}>
                        Agendamentos
                      </Text>
                      <Flex gap="1">
                        <span>
                          {format(
                            new Date(
                              item.DATA_AGENDAMENTO__c?._seconds * 1000 || 0
                            ),
                            'dd/MM/yyyy'
                          )}{' '}
                          às{' '}
                          {format(
                            new Date(
                              item.DATA_AGENDAMENTO__c?._seconds * 1000 || 0
                            ),
                            'HH:mm'
                          )}{' '}
                          -{' '}
                        </span>
                        <Text
                          bg="#001E64"
                          w="fit-content"
                          textColor={'white'}
                          px="0.3rem"
                          rounded={'md'}
                        >
                          {
                            dateFnsDayPeriod[
                              format(
                                new Date(
                                  item.DATA_AGENDAMENTO__c?._seconds * 1000 || 0
                                ),
                                'B',
                                { locale: ptBR }
                              )
                            ]
                          }
                        </Text>
                      </Flex>
                    </Box>
                  )}
                {item?.ABORDAGEM_N2__c && item?.STATUS__c === 'EmNegociacao' && (
                  <Box my="0.4rem" fontSize={'1rem'}>
                    <Text fontWeight="bold">Em Negociação</Text>
                    <Text>
                      {item?.ABORDAGEM_N2__c === 'cotacao' && 'Cotação enviada'}
                      {item?.ABORDAGEM_N2__c === 'transmissao' &&
                        'Proposta transmitida'}
                    </Text>
                  </Box>
                )}
                {item?.ABORDAGEM_N2__c &&
                  item?.STATUS__c === 'Concluido' &&
                  item?.ABORDAGEM__c === false && (
                    <Box my="0.4rem" fontSize={'1rem'}>
                      <Text fontWeight="bold">Motivo</Text>
                      <Text>{setReason(item?.ABORDAGEM_N2__c)}</Text>
                    </Box>
                  )}

                <LeadBtnTooltipComponent
                  tooltip={
                    getVisualizedStatus(
                      item.LEAD_VISUALIZADO__c,
                      item.USUARIOS_VISUALIZACOES__c
                    ) === 'visualizado'
                      ? 'Lead visualizado'
                      : 'Lead não visualizado'
                  }
                  side="bottom"
                  arrowOffset={100}
                >
                  <Box display="flex" justifyContent="flex-start">
                    <Link
                      state={{
                        isGestor: !(
                          userRef.current === filterObject?.headers?.login ||
                          !filterObject?.headers?.login
                        )
                      }}
                      to={'/corretor/leads/' + item.ID_LEAD__c}
                      className={`tw-flex tw-items-center tw-gap-2 tw-justify-center tw-w-[100%] tw-text-center tw-h-[2.5rem] tw-cursor-pointer tw-text-white tw-rounded-full tw-text-[1rem] ${getColorStatus(
                        item,
                        'bg'
                      )}`}
                    >
                      {searchVisualized(
                        item.LEAD_VISUALIZADO__c,
                        item.USUARIOS_VISUALIZACOES__c
                      )}
                      <span> Ver Detalhes</span>
                    </Link>
                  </Box>
                  <Text mt="0.5rem" fontSize={'0.8rem'} color="#5A5A5A">
                    {item.LEAD_VISUALIZADO__c === true
                      ? 'Lead visualizado'
                      : 'Lead não visualizado'}
                  </Text>
                </LeadBtnTooltipComponent>
                <Divider my="1rem" />
                <Box>
                  <Text fontWeight="bold" fontSize={'1rem'}>
                    Alterar Status do lead
                  </Text>
                  <select
                    className={
                      'tw-h-[2.5rem] tw-w-full tw-text-start tw-rounded-full tw-color-white tw-border-solid tw-border-black tw-border-[0.1rem]'
                    }
                    placeholder={'Selecione status do lead'}
                    disabled={
                      !(
                        userRef.current === filterObject?.headers?.login ||
                        !filterObject?.headers?.login
                      )
                    }
                    onChange={(e) => {
                      handleUpdateLead(e.target.value, item);
                    }}
                  >
                    <option key="index" value={''} style={{ color: '#828282' }}>
                      Selecione status do lead
                    </option>
                    {showStatus(item.STATUS__c).map((option, index) => {
                      return (
                        <option
                          key="index"
                          value={option.id}
                          style={{ color: 'black' }}
                        >
                          {option.nome}
                        </option>
                      );
                    })}
                  </select>
                </Box>
              </Box>
            );
          })
        ) : (
          <Box
            w="100%"
            mt="1rem"
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Spinner />
          </Box>
        )}
        {mobileLeads?.length <= 0 && (
          <Box>
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-mt-12">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Você não possui leads nesse status
              </p>
            </div>
          </Box>
        )}
        <HStack justifyContent="center" pt="5px">
          {loadingMoreLeads ? <Spinner /> : <></>}
        </HStack>
      </Box>

      <Box justifyContent="center" alignItems="center">
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={onClose}
          size="md"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalChangeStatus
              getLeads={updateLead}
              lead={saveStatus}
              status={newStatus}
              onOpenModal={onOpen}
              onCloseModal={onClose}
              isMobile={true}
            />
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};
